/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const featureProfileConfig = {
  image:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.public/vlinder-logo.png',
  title: 'Bharat Life Insurance',
  subtitle: 'Your Organization Profile',
  buttons: [
    {
      key: 'edit',
      title: 'Edit Profile',
      color: 'primary',
    },
  ],
  listItems: [
    {
      title: 'Full Name',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/name-icon.png',
    },
    {
      title: 'Street Address',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/street-icon.png',
    },
    {
      title: 'City',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/city-icon.png',
    },
    {
      title: 'Country',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/country-icon.png',
    },
    {
      title: 'Email',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/email-icon.png',
    },
    {
      title: 'Telephone',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/phone-icon.png',
    },
    {
      title: 'Occupation',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/occupation-icon.png',
    },
  ],
  // listItems:[
  //     {
  //         title:"Email",
  //         subTitle:"-",
  //         icon:"https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/email-icon.png"
  //     },
  //     {
  //         title:"Phone Number",
  //         subTitle:"-",
  //         icon:"https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/phone-icon.png"

  //     },
  //     {
  //         title:"Address",
  //         subTitle:"-",
  //         icon:"https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/street-icon.png"

  //     },
  //     {
  //         title: "City",
  //         subTitle: "-",
  //         icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/city-icon.png"
  //     },
  //     {
  //         title: "Country",
  //         subTitle: "-",
  //         icon: "https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/country-icon.png"
  //     },
  //     {
  //         title:"Website",
  //         subTitle:"-",
  //         icon:"https://static.thenounproject.com/png/3437694-200.png"

  //     }
  // ],
  orglistItems: [
    {
      title: 'Email',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/email-icon.png',
    },
    {
      title: 'Phone Number',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/phone-icon.png',
    },
    {
      title: 'Address',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/street-icon.png',
    },
    {
      title: 'City',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/city-icon.png',
    },
    {
      title: 'Country',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/country-icon.png',
    },
    {
      title: 'Website',
      subTitle: '-',
      icon: 'https://static.thenounproject.com/png/3437694-200.png',
    },
  ],
};
